const btnBase =
  'min-w-[32px] h-[32px] px-2 rounded-lg border text-[12px] font-medium transition-colors';
const btnIdle = `${btnBase} border-[#D2D8DF] text-[#353E4A] hover:bg-[#F0F2F4]`;
const btnActive = `${btnBase} border-[#FA3F58] bg-[#FA3F58] text-white`;
const btnDisabled = `${btnBase} border-[#D2D8DF] text-[#353E4A] opacity-40 cursor-not-allowed`;

const WINDOW = 2;
function getPageNumbers(page, totalPages) {
  const pages = [];
  const start = Math.max(1, page - WINDOW);
  const end = Math.min(totalPages, page + WINDOW);
  if (start > 1) {
    pages.push(1);
    if (start > 2) pages.push('...');
  }
  for (let i = start; i <= end; i++) pages.push(i);
  if (end < totalPages) {
    if (end < totalPages - 1) pages.push('...');
    pages.push(totalPages);
  }
  return pages;
}

const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];

const Pagination = ({
  page,
  totalPages,
  pageSize,
  total,
  pageSizeOptions = PAGE_SIZE_OPTIONS,
  onPageSizeChange,
  onPrev,
  onNext,
  onGoToPage
}) => {
  if (!totalPages || totalPages < 1) return null;

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 mt-4">
      <div className="flex items-center gap-2">
        {typeof total === 'number' && (
          <span className="text-[12px] text-[#5F6F86]">{total} total</span>
        )}
        {onPageSizeChange && (
          <select
            value={pageSize}
            onChange={(e) => onPageSizeChange(Number(e.target.value))}
            className="h-[32px] border border-[#D2D8DF] rounded-lg px-2 text-[12px] text-[#353E4A] bg-white focus:outline-none focus:ring-2 focus:ring-[#FA3F58]/20"
          >
            {pageSizeOptions.map((size) => (
              <option key={size} value={size}>
                {size} / page
              </option>
            ))}
          </select>
        )}
      </div>

      <div className="flex items-center gap-1.5">
        <button
          type="button"
          className={page <= 1 ? btnDisabled : btnIdle}
          disabled={page <= 1}
          onClick={onPrev}
        >
          Prev
        </button>

        {getPageNumbers(page, totalPages).map((p, i) =>
          p === '...' ? (
            <span key={`gap-${i}`} className="px-1 text-[12px] text-[#97A3B5]">
              …
            </span>
          ) : (
            <button
              key={p}
              type="button"
              className={p === page ? btnActive : btnIdle}
              onClick={() => onGoToPage(p)}
            >
              {p}
            </button>
          )
        )}

        <button
          type="button"
          className={page >= totalPages ? btnDisabled : btnIdle}
          disabled={page >= totalPages}
          onClick={onNext}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Pagination;
